import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FavoriteToggleComponent } from './favorite-toggle.component';


@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [FavoriteToggleComponent],
    declarations: [FavoriteToggleComponent],
    providers: [],
})
export class FavoriteToggleModule { }
